import React from 'react';

/* eslint-disable react/prop-types */
export default function ({ color }) {
  // viewBox="0 0 21 22"
  return (
    <g fill={color}>
      <path d="M19.83 2.05h-7.52v-.71l-.01-.1a.6.6 0 0 0-.68-.5L.5 2.49a.6.6 0 0 0-.51.6v15.85c0 .3.21.56.5.6l11.12 1.76h.09a.6.6 0 0 0 .39-.14.6.6 0 0 0 .2-.46v-2.03h7.53a.6.6 0 0 0 .6-.61V2.66a.6.6 0 0 0-.6-.61Zm-7.52 13.54h2.65v1.85h-2.65V15.6Zm-1.2 4.39L1.2 18.4V3.63l9.92-1.57v17.92Zm8.13-14.85h-3.09V3.27h3.09v1.86Zm-6.93 6.15V9.43h2.65v1.85h-2.65Zm2.65-3.07h-2.65V6.35h2.65v1.86Zm-2.65 4.3h2.65v1.85h-2.65v-1.85Zm3.84 0h3.08v1.85h-3.08v-1.85Zm0-1.23V9.43h3.08v1.85h-3.08Zm0-3.07V6.35h3.08v1.86h-3.08Zm-1.2-3.08H12.3V3.27h2.66v1.86Zm1.2 10.46h3.08v1.86h-3.08v-1.86Z" />
      <path d="m6.87 10.58 2.35-3.63a.62.62 0 0 0-.16-.82.58.58 0 0 0-.84.15l-2.06 3.2-2.09-3.23A.58.58 0 0 0 3.68 6a.58.58 0 0 0-.44.1.6.6 0 0 0-.24.4c-.03.17 0 .33.1.46l2.34 3.62-2.35 3.62a.6.6 0 0 0 .5.95c.2 0 .38-.1.5-.28l2.06-3.2 2.07 3.2a.59.59 0 0 0 .83.17.6.6 0 0 0 .25-.38.64.64 0 0 0-.09-.46l-2.34-3.62Z" />
    </g>
  );
}
